<template>
  <div class="member-list">
    <div class="title-info">
      <div class="h1">{{ pageTitle }}</div>
    </div>
    <div class="list-section">
      <div v-for="(item, index) in list" :key="item.id || index" class="list-item" @click="goDetail(item)">
        <!-- 球员：右上角状态（未完成注册 / 未支付 / 已完成） -->
        <span
          v-if="type === 'player' && showPlayerStatusTag && getPlayerStatus(item)"
          class="item-status"
          :class="{
            danger: getPlayerStatus(item) === '未完成注册' || getPlayerStatus(item) === '未支付',
            success: getPlayerStatus(item) === '已完成'
          }"
        >
          {{ getPlayerStatus(item) }}
        </span>
        <div class="avatar" v-if="item.avatar">
          <img :src="imageView(item.avatar)"  alt="" />
        </div>
        <div class="info">
          <!-- 球员：姓名、出生日期、性别 -->
          <template v-if="type === 'player'">
            <div class="info-name">{{ item.trueName || '-' }}</div>
            <div class="info-row">{{ formatBirthday(item.bmBirthday) }}</div>
            <div class="info-row">{{ formatGender(item.gender) }}</div>
          </template>
          <!-- 工作人员：姓名、联系方式、职务 -->
          <template v-else>
            <div class="info-name">{{ item.name || '-' }}</div>
            <div class="info-row">{{ item.mobile || '-' }}</div>
            <div class="info-row">{{ item.role || '-' }}</div>
          </template>
        </div>
      </div>
      <div v-if="list.length === 0">
        <!-- 球员名单 + 非注册球队 + 允许邀请（0/2）时：展示可点击图片，点击同邀请逻辑 -->
        <div v-if="canShowInviteEmptyImage" class="empty-invite" @click="weChatShare">
          <img src="https://images.snsports.cn/Fkg02mfZR9SylBM6d8GiEckVbISc" alt="邀请队员" />
        </div>
        <van-empty v-else :description="type === 'player' ? '暂无球员' : '暂无工作人员'" />
      </div>
    </div>
    <div class="bottom-actions" v-if="showAddButton" :class="{ 'two-btns': showRightButton && canShowMainActionBtn }">
      <div class="operation-box" v-if="showRightButton">
        <div v-if="!isRegisterType" @click="weChatShare">
          <img src="@/assets/images/wx-round-icon.png" />
          邀请成员
        </div>
        <div v-if="isRegisterType" @click="remindPay">
          <img src="https://images.snsports.cn/Fl7_a_2uxLYAvXhFfWocRi6cBFK3" />
          提醒付款
        </div>
      </div>
      <div v-if="canShowMainActionBtn" class="right" @click="goAdd" :style="{ 'background-color': jetlympic ? '#00A7FF' : 'var(--bg3)' }">
        {{ addButtonText }}
      </div>
    </div>
    <ShareLayer :shareShow="shareShow" @close="shareShow = false" />
  </div>
</template>

<script>
import { Toast, Empty } from 'vant'
import { getBMMatchTeamSignup } from '@/api/match'
import { QNImageUtil, DateUtil } from '@/utils'
import { isWeChatMiniApp } from '@/utils'
import { AppType } from '@/constants/appType'
import ShareLayer from '@/components/ShareLayer'
import wx from 'weixin-js-sdk'
import Vue from 'vue'
Vue.use(Empty)
export default {
  name: 'MemberList',
  components: { ShareLayer },
  data() {
    return {
      teamId: '',
      matchId: '',
      unionMatchId: '',
      type: 'player', // 'player' | 'officer'
      team: {},
      match: {},
      list: [],
      jetlympic: false,
      shareShow: false
    }
  },
  computed: {
    /** 顶部标题 */
    pageTitle() {
      return this.type === 'player' ? '球员名单' : '工作人员名单'
    },
    /** 是否显示底部添加按钮：未提交或已退回时显示 */
    showAddButton() {
      return this.team && (this.team.isSubmit === 0 || this.team.auditStatus === -1)
    },
    /** 是否已达人数上限 */
    isLimitReached() {
      if (this.type === 'player') {
        return this.list.length >= (this.match.teamMemberLimitCount || 0)
      }
      return this.list.length >= (this.match.maxOffice || 0)
    },
    /** 是否注册报名类型（仅限年度注册）：注册类型显示提醒付款，非注册类型显示邀请入队 */
    isRegisterType() {
      return this.match && this.match.publicSignUp === 2
    },
    /** 球员项状态角标是否展示：非注册类型仅在开启支付后展示 */
    showPlayerStatusTag() {
      if (this.type !== 'player') return false
      if (this.isRegisterType) return true
      return Number(this.match && this.match.feeMethod) === 1
    },
    /** 球员列表时是否显示右侧按钮：注册类型显示提醒付款，非注册且允许邀请时显示邀请入队 */
    showRightButton() {
      if (this.type !== 'player') return false
      if (this.isRegisterType) return true
      return this.match && this.match.teamLeaderAddPlayerOnly !== 1
    },
    /** 底部添加按钮文案（球员名单 + 非注册球队）：0/1=添加队员，2=去报名 */
    addButtonText() {
      if (this.type === 'player' && !this.isRegisterType) {
        const mode = this.match && this.match.teamLeaderAddPlayerOnly
        if (mode === 2) {
          return '去报名'
        }
        return '添加队员'
      }
      return this.type === 'player' ? '添加队员' : '添加'
    },
    /** 去报名模式下：是否已存在领队本人报名 */
    hasMyselfPlayer() {
      if (this.type !== 'player') return false
      const arr = Array.isArray(this.list) ? this.list : []
      return arr.some(p => Number(p && p.isMyself) === 1)
    },
    /** 右侧主按钮是否展示：去报名且已存在本人报名时隐藏 */
    canShowMainActionBtn() {
      if (!this.showAddButton) return false
      if (this.addButtonText === '去报名' && this.hasMyselfPlayer) return false
      return true
    },
    /** 空状态是否展示可点击邀请图片（球员名单 + 非注册球队，且非仅队长报名=1） */
    canShowInviteEmptyImage() {
      if (this.type !== 'player') return false
      if (this.isRegisterType) return false
      const mode = this.match && this.match.teamLeaderAddPlayerOnly !== 1
      return mode
    }
  },
  mounted() {
    if (window.localStorage.getItem('jetlympic')) this.jetlympic = true
    this.teamId = this.$route.query.teamId || ''
    this.matchId = this.$route.query.matchId || ''
    this.unionMatchId = this.$route.query.unionMatchId || ''
    const t = (this.$route.query.type || 'player').toLowerCase()
    this.type = t === 'officer' ? 'officer' : 'player'
    this.setPageTitle()
    this.loadList()
  },
  methods: {
    setPageTitle() {
      const title = this.type === 'player' ? '队员名单' : '工作人员'
      document.title = title
      if (this.$route.meta) this.$route.meta.title = title
    },
    loadList() {
      const params = { matchId: this.matchId }
      if (this.teamId) params.teamId = this.teamId
      getBMMatchTeamSignup(params).then(res => {
        if (!res || !res.data) return
        const data = res.data
        this.team = data.team || {}
        this.match = data.match || {}
        this.list = this.type === 'player' ? (data.players || []) : (data.officers || [])
      })
    },
    imageView(img) {
      return img ? QNImageUtil.imageView(img) : ''
    },
    formatBirthday(bmBirthday) {
      return bmBirthday ? DateUtil.parseDateTime(bmBirthday, '{y}-{m}-{d}') : '-'
    },
    formatGender(gender) {
      if (gender === '1') return '男'
      if (gender === '2') return '女'
      return '-'
    },
    /**
     * 球员项状态文案（与选择球队时的 registerStep/registerStatus 判断一致）
     * registerStep 对应 currentStep，registerStatus 对应 currentStatus
     * 未支付 = 参赛报名未支付（orderStatus 非 1/2），非注册未支付
     */
    getPlayerStatus(item) {
      if (this.type !== 'player' || !item) return ''
        // const step = (item.registerStep != null ? item.registerStep : item.currentStep)
        // const stepStr = (step || '').toString()
      // 1. 未完成注册：与查看球队时一致，非 Team.Review 且非 Team.Fee 视为未完成注册
      if (item.registerStatus === 'ORDER_CREATED' || item.registerStatus === 'SUBMITTED') {
        return '未完成注册'
      }
      // 2. 未支付：仅在开启付费且球员独立付费时才展示（feeMethod=1）
      const isOpenCharge = Number(this.match && this.match.isOpenCharge) === 1
      const isPlayerPay = Number(this.match && this.match.feeMethod) === 1
      if (isOpenCharge && isPlayerPay) {
        const orderStatus = item.orderStatus != null ? Number(item.orderStatus) : null
        if (orderStatus !== 1 && orderStatus !== 2) {
          return '未支付'
        }
      }
      // 3. 已完成
      return '已完成'
    },
    goDetail(item) {
      if (this.type === 'player') {
        this.$router.push({
          path: '/entry-page/entry-info-player',
          query: {
            teamId: this.teamId,
            matchId: this.matchId,
            unionMatchId: this.unionMatchId,
            playerId: item.id,
            role: 'captain'
          }
        })
      } else {
        this.$router.push({
          path: '/entry-page/officer-form',
          query: {
            teamId: this.teamId,
            matchId: this.matchId,
            unionMatchId: this.unionMatchId,
            officerId: item.id
          }
        })
      }
    },
    goAdd() {
      if (this.isLimitReached) {
        const msg = this.type === 'player' ? '队员数量已达到上限' : '工作人员数量已达到上限'
        Toast.fail(msg)
        return
      }
      if (this.isRegisterType) {
        this.$router.push({
          path: '/entry-page/member-select-list',
          query: {
            teamId: this.teamId,
            matchId: this.matchId,
            unionMatchId: this.unionMatchId,
            regTeamId: this.team.regTeamId || '',
            type: this.type
          }
        })
        return
      }
      if (this.type === 'player') {
        this.$router.push({
          path: '/entry-page/player-info',
          query: {
            teamId: this.teamId,
            matchId: this.matchId,
            unionMatchId: this.unionMatchId,
            role: 'captain'
          }
        })
      } else {
        this.$router.push({
          path: '/entry-page/officer-form',
          query: {
            teamId: this.teamId,
            matchId: this.matchId,
            unionMatchId: this.unionMatchId,
            officerId: ''
          }
        })
      }
    },
    /** 提醒付款（注册报名类型） */
    remindPay() {
      // const link = 'http://192.168.8.3:8080/#/entry-page/registration-order-list?teamId=' + this.teamId + '&matchId=' + this.matchId + '&unionMatchId=' + this.unionMatchId
      const link = process.env.VUE_APP_BM_MATCH + '#/entry-page/registration-order-list?teamId=' + this.teamId + '&matchId=' + this.matchId + '&unionMatchId=' + this.unionMatchId
      const shareObj = {
        title: this.match.unionMatchName,
        abstract: '请尽快完成报名缴费',
        image: 'https://images.snsports.cn/FkoTEDpLVCBuLdoDubPF01BYpqCF',
        link: '/pages/webview/index?redirect=' + encodeURIComponent(link)
      }
      wx.miniProgram.postMessage({
        data: {
          type: 'setShareData',
          shareData: {
            title: shareObj.title,
            desc: shareObj.abstract,
            imageUrl: shareObj.image,
            path: '/pages/webview/index?redirect=' + encodeURIComponent(link)
          }
        }
      })
      Toast('请点击右上角···完成分享')
    },
    /** 邀请入队（非注册类型，与 entry-info 原邀请逻辑一致） */
    async weChatShare() {
      if (!AppType.isInWeChat()) {
        Toast.fail('请在微信环境下打开')
        return
      }
      const isMiniApp = await isWeChatMiniApp()
      if (isMiniApp) {
        wx.miniProgram.navigateTo({
          url: `/pages/share/index?unionMatchId=${this.unionMatchId}&matchId=${this.matchId}&teamId=${this.teamId}`
        })
      } else {
        this.shareShow = true
        const shareObj = {
          title: this.team.name + '邀请您加入',
          abstract: this.team.name + '邀请您参加' + (this.match.unionMatchName || '') + '/' + (this.match.group || this.match.matchGroupName || '') + '的比赛',
          link: process.env.VUE_APP_BM_MATCH + '#/entry-page/wx-invite-landing?unionMatchId=' + this.unionMatchId + '&matchId=' + this.matchId + '&teamId=' + this.teamId,
          image: this.match.icon ? QNImageUtil.imageView(this.match.icon) : ''
        }
        this.wxShare(shareObj)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.member-list {
  min-height: 100vh;
  background: #f6f6f8;
  padding-bottom: 80px;
}
.title-info {
  padding: 16px;
  background: #fff;
  margin-bottom: 12px;
  .h1 {
    font-size: 18px;
    color: #1d2129;
    font-weight: 500;
  }
}
.list-section {
  padding: 0px;
}
.list-item {
  position: relative;
  display: flex;
  align-items: flex-start;
  padding: 12px 16px;
  background: #fff;
  border-radius: 8px;
  margin-bottom: 12px;
  .item-status {
    position: absolute;
    top: 12px;
    right: 16px;
    font-size: 12px;
    color: var(--font-color2, #606266);
    &.danger {
      color: #BC2D2F;
    }
    &.success {
      color: #0FAC7F;
    }
  }
  .avatar {
    width: 80px;
    height: 80px;
    border-radius: 4px;
    overflow: hidden;
    flex-shrink: 0;
    background: #e8e8e8;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .info {
    flex: 1;
    min-width: 0;
    margin-left: 12px;
    .info-name {
      font-size: 15px;
      font-weight: 500;
      color: #1d2129;
    }
    .info-row {
      font-size: 13px;
      font-weight: 500;
      color: #666666;
      margin-top: 4px;
    }
  }
}
.bottom-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px 16px;
  padding-bottom: 22px;
  background: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .operation-box{
    flex: 1;
    div{
      display: inline-block;
      text-align: center;
      font-size: 12px;
      color: #606266;
      font-weight: 500;
      img{
        display: block;
        width: 26px;
        margin: 0 auto 2px;
      }
    }
  }
  .right{
    width: 117px;
    height: 45px;
    border-radius: 69px;
    font-size: 15px;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    line-height: 45px;
    flex-shrink: 0;
  }


}
.empty-invite{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  img{
    width: 131px;
    height: 98px;
    margin-top: 140px;
  }
}
</style>
